import { ResetPasswordPage } from './ResetPasswordPage'
import { withResetPasswordPage } from './withResetPasswordPage'

const ConnectedResetPasswordPage = withResetPasswordPage(ResetPasswordPage)

export { ConnectedResetPasswordPage as ResetPasswordPage }
